import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";

export default class SettingsOrganizationProfile extends SettingsModule {

    constructor() {
        super({
            name                     : "Organization Profile",
            description              : "",
            svgIcon                  : "isvg-profile",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/profile",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.canDisable         = false
        this.hasStatus          = false
    }

}
